import { useQuery } from "@apollo/client";
import { GET_RAP_INSTANCES } from "./RemoteCollectorsApi";
import { useEffect, useState } from "react";

export interface RapInstance {
  id?: number | string;
  name?: string;
  proxy?: string | null;
  enabled?: boolean;
  last_connected_time?: string | null;
  created_time?: string | null;
  created_by?: string | null;
  status?: string | null;
}

export interface RapInstancesResponse {
  rap_instances?: {
    rap_instances?: RapInstance[];
  };
}

export interface MappedRapInstance {
  label?: string;
  value?: number | string;
}

export interface UseRemoteCollectorsReturn {
  mappedRapInstances?: MappedRapInstance[];
  rapInstances?: RapInstancesResponse;
  loading: boolean;
}

const useRemoteCollectors = (): UseRemoteCollectorsReturn => {
  const { data: rapInstances, loading } =
    useQuery<RapInstancesResponse>(GET_RAP_INSTANCES);
  const [mappedRapInstances, setMappedRapInstances] =
    useState<MappedRapInstance[]>();

  useEffect(() => {
    if (!!rapInstances) {
      setMappedRapInstances(
        rapInstances.rap_instances?.rap_instances?.map((instance) => ({
          label: instance.name,
          value: instance.id,
        }))
      );
    }
  }, [rapInstances]);

  return { mappedRapInstances, rapInstances, loading };
};

export default useRemoteCollectors;
